// extracted by mini-css-extract-plugin
export default {"container":"MyButton_container__kxfsZ","button":"MyButton_button__JslM4","blue":"MyButton_blue__O35Am","green":"MyButton_green__GAFcl"};